export default __webpack_public_path__ + "600aa2f.png";